<template lang="pug">
  .container
    .columns.is-vcentered
      .column.is-3
        label.label Fecha Salida:
        .field
          .control
            flat-pickr(
              v-model='fecha'
              :config="config"
              class="input"
            )
      .column.is-offset-1.is-3
        .field
          label.label tag
            .control.has-icons-left
              .select.is-dark.is-rounded
                select(v-model="tagSel" :disabled="isDisabled")
                  option(v-for="t in tags" :key="t.id" :value="t") {{ t.numero }}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-offset-1.is-3
        .field
          label.label Cruce
            .control.has-icons-left
              .select.is-dark.is-rounded
                select(v-model="cruceSel")
                  option(v-for="r in cruces" :key="r.id" :value="r") {{ r.nombre }}
              .icon.is-small.is-left
                i.fas.fa-map-pin
    .columns.is-vcentered
      .column.is-2
        .field
          label.label Cantidad
            .control.has-icons-left.has-icons-right
              input.input.is-dark(
                type='text', 
                placeholder='00.00',
                v-model="cantidad",
              )
      .column.is-offset-2.is-3.has-text-centered
        input#chc.is-checkradio.is-black(type='radio', value='0' v-model='transaccion')
        label.is-size-6(for='chc') Cargo
        input#cha.is-checkradio.is-black(type='radio', value='1' v-model='transaccion')
        label.is-size-6(for='cha') Abono
      .column.is-offset-1.is-3
        .field
          label.label Clase
            .control.has-icons-left
              .select.is-dark.is-rounded
                select(v-model="clase")
                  option(value="1") 1
                  option(value="2") 2
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          button.delete(@click="deleteNotificacion")
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      .column.is-offset-4.is-4
        a.button.is-block.is-black.is-rounded(@click="checkForm")
          | Guardar Movimiento
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'

  export default {
    name: 'FormNuevoMovimientoTag',
    components: {
      flatPickr,
    },
    props: {
      tags: {
        type: Array,
        default: [],
      },
      cruces: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        isLoading: false,
        isDisabled: false,
        config: {
          wrap: false, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d H:i',
          altInput: true,
          dateFormat: 'Y-m-d H:i',
          locale: Spanish, // locale for this instance only
          enableTime: true       
        },
        fecha: moment().format('YYYY-MM-DD HH:mm'),
        periodo: '',
        transaccion: '0',
        tagSel: {},
        cruceSel: {},
        cantidad: 0,
        clase: '1',
        isDisabled: false,
        datosFaltantes: [],
      }
    },
    watch: {
      fecha() {
        this.obtenerPeriodo()
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerPeriodo()
      },

      checkForm () {
        this.datosFaltantes = []
        if (Object.keys(this.tagSel).length > 0 && this.cantidad > 0 && Object.keys(this.cruceSel).length > 0 ) {
          this.saveForm()
        } else {
          console.log('Algo falta')
          if (Object.keys(this.tagSel).length == 0) {
            this.datosFaltantes.push('La tag es requerida')
          }

          if (Object.keys(this.cruceSel).length == 0) {
            this.datosFaltantes.push('La respuesta es requerida')
          }

          if (this.cantidad == 0) {
            this.datosFaltantes.push('La cantidad debe ser mayor a 0')
          }

        }
      },
      saveForm () {
        const abono = this.transaccion === '1' ? Number(this.cantidad) : 0
        const cargo = this.transaccion === '0' ? Number(this.cantidad) : 0
        const myObj = {
          fecha: this.fecha,
          periodo: this.periodo,
          tag: this.tagSel,
          cruce: this.cruceSel,
          cargo: cargo,
          abono: abono,
          transaccion: this.transaccion,
          clase: parseInt(this.clase)
        }
        this.$emit('saveForm', myObj)
      },

      obtenerPeriodo () {
        const fechaAct = moment(this.fecha).format('D')
        const periodo = fechaAct > 15 ? 2 : 1
        this.periodo = `${moment(this.fecha).format('YYYYMM')}_${periodo}`
      },

      deleteNotificacion () {
        this.datosFaltantes = []
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/FormNuevoMovimientoTag.vue